import React, { ChangeEvent, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useRouteMatch } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import { BottomNavigation } from "@material-ui/core";
import { SpeedDial, SpeedDialAction, SpeedDialIcon } from "@material-ui/lab";
import GetAppIcon from "@material-ui/icons/GetApp";
import AddAPhotoIcon from "@material-ui/icons/AddAPhoto";
import AddIcon from "@material-ui/icons/Add";
import { addImageAction, selectImageCount } from "../Camera/cameraSlice";
import getBase64 from "../../util/getBase64";
import imageCompression from "browser-image-compression";
import LoadingScreen from "../../LoadingScreen";
import FloatError from "../../Error/FloatError";

const useStyles = makeStyles((theme) => ({
  bottomNav: {
    position: "fixed",
    bottom: 0,
    left: 0,
    right: 0,
    height: 56,
    backgroundColor: theme.palette.primary.secondary,
    zIndex: 1000,
  },
  speedDial: {
    position: "fixed",
    bottom: 28,
    left: "50%",
    transform: "translateX(-50%)",
    zIndex: 1100,
    "& .MuiSpeedDial-fab": {
      width: 56,
      height: 56,
      backgroundColor: theme.palette.primary.dark,
      "&:hover": {
        backgroundColor: theme.palette.primary.dark,
      },
    },
  },
}));

//Container page for the receipt add options (upload & take a pic)
const ReceiptAddBottomNav = () => {
  const [loading, setLoading] = useState(false);
  const [apiError, setApiError] = useState("");
  const [showApiError, setShowApiError] = useState(false);
  const [speedDialOpen, setSpeedDialOpen] = useState(false);
  const inputFile = useRef<any>(null);
  const imageCount = useSelector(selectImageCount);
  const dispatch = useDispatch();
  let history = useHistory();
  let { url } = useRouteMatch();
  const classes = useStyles();
  const openDeviceFileDialog = () => inputFile.current.click();

  const handleCameraPicture = (e: ChangeEvent<HTMLInputElement>) => {
    if (!e.target.files) return;
    let imageFile = e.target.files[0];

    setLoading(true);

    /**
     * Check that it's actually image type before running it throuh compressing function
     */
    if (imageFile) {
      const fileExt = imageFile.name.split(".").pop();
      let fileExtLower = fileExt ? fileExt.toLowerCase() : "";
      if (fileExtLower !== "png" && fileExtLower !== "jpg" && fileExtLower !== "jpeg") {
        console.log("Image extension was not image:", fileExt);
        setApiError("Tiedoston tulee olla kuva");
        setShowApiError(true);
        return;
      }
    }

    const options = {
      maxSizeMB: 1,
      maxWidthOrHeight: 1920,
      useWebWorker: true,
    };
    if (imageFile) {
      imageCompression(imageFile, options).then((compressedFile) => {
        setLoading(true);
        getBase64(compressedFile)
          .then((result: any) => {
            dispatch(
              addImageAction({
                img: result,
                id: imageCount,
              })
            );
            setLoading(false);
            history.push("/customer/camera/gallery");
          })
          .catch((err: Error) => {
            console.log(err);
          });
        setLoading(false);
        history.push("/customer/camera/gallery");
      });
    }
  };

  const actions = [
    { 
      icon: <AddAPhotoIcon />, 
      name: "Ota kuva", 
      onClick: () => {
        setSpeedDialOpen(false);
        openDeviceFileDialog();
      }
    },
    { 
      icon: <GetAppIcon />, 
      name: "Lataa tiedosto", 
      onClick: () => {
        setSpeedDialOpen(false);
        history.push(`${url}/receipt/file/upload`);
      }
    },
  ];

  return (
    <>
      <FloatError
        message={apiError}
        show={showApiError}
        handleClose={() => setShowApiError(false)}
      />
      
      {/* Bottom Navigation Bar */}
      <BottomNavigation className={classes.bottomNav} showLabels={false} />

      {/* Centered FAB with SpeedDial */}
      <SpeedDial
        ariaLabel="Lisää tosite"
        className={classes.speedDial}
        icon={<SpeedDialIcon icon={<AddIcon />} />}
        onClose={() => setSpeedDialOpen(false)}
        onOpen={() => setSpeedDialOpen(true)}
        open={speedDialOpen}
        direction="up"
      >
        {actions.map((action) => (
          <SpeedDialAction
            key={action.name}
            icon={action.icon}
            tooltipTitle={action.name}
            onClick={action.onClick}
          />
        ))}
      </SpeedDial>
      <input
        ref={inputFile}
        capture="environment"
        accept="image/*"
        type="file"
        hidden
        multiple
        onChange={handleCameraPicture}
      />
      <LoadingScreen
        loading={loading}
        loadingText="Ladataan kuvaa... Odota hetki..."
      />
    </>
  );
};
export default ReceiptAddBottomNav;
